(function () {
  'use strict';



  function openCcm() {
    if (window.CCM19 && typeof window.CCM19.show === 'function') {
      window.CCM19.show();
      return true;
    }
    if (window.CCM && typeof window.CCM.openWidget === 'function') {
      window.CCM.openWidget();
      return true;
    }
    if (window.__ccm && typeof window.__ccm.openWidget === 'function') {
      window.__ccm.openWidget();
      return true;
    }
    return false;
  }

  function initCcmTriggers() {
    document.querySelectorAll('[data-ccm-trigger]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        if (!openCcm()) {
          console.warn('[footer] CCM19 widget API not detected; verify ccm19 script loaded.');
        }
      });
    });
  }

  function init() {
    initCcmTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
